<template>
  <div>
    <app-header></app-header>
    <h1 class="display-4 text-center">Register for Chrono Logic</h1>
    <div class="container-fluid w-50 mt-5 bg-light">
      <div class="btn-danger text-center mb-3" v-show="errors !== null" dismissible @dismissed="errors = null">
        <div v-for="(error, index) in errors" v-bind:key="index">
          {{ error[0] }}
        </div>

      </div>
      <form @submit.prevent="register">
        <div class="form-group">
          <label class="label">E-mail</label>
          <input placeholder="Enter your e-mail address" type="text" class="input form-control" @input="$v.form.email.$touch()" v-model.lazy.trim="form.email" />
          <div v-if="$v.form.email.$touch">
            <div class="text-danger" v-if="!$v.form.email.required">Email is required!</div>
            <div class="text-danger" v-if="!$v.form.email.email">Email is not valid!</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Company name</label>
          <input placeholder="Enter your company name" type="text" class="input form-control" @input="$v.form.company.$touch()" v-model.trim="form.company" />
          <div v-if="$v.form.company.$dirty">
            <div class="text-danger" v-if="!$v.form.company.required">Company name is required!</div>
          </div>
        </div>

        <div class="form-group">
              <label class="label">System Company</label>
              <select class="form-control" @change="$v.form.sysco.$touch()" v-model="form.sysco">
                <option v-for="s in syscos" v-bind:key="s.sysCoId" v-bind:value="s.sysCoId">{{s.sysCoName}}</option>
              </select>
              <div v-if="$v.form.sysco.$dirty">
              <div class="text-danger" v-if="!$v.form.sysco.required">System Company is required</div>
            </div>
          </div>

         <div class="form-group">
              <label class="label">Country</label>
              <select class="form-control" @change="$v.form.country.$touch()" v-model="form.country">
                <option v-for="c in countries" v-bind:key="c.countryId" v-bind:value="c.countryId">{{c.countryName}}</option>
              </select>
              <div v-if="$v.form.country.$dirty">
              <div class="text-danger" v-if="!$v.form.country.required">Country name is required</div>
            </div>
          </div>

        <div class="form-group">
          <label class="label">Language</label>
          <select class="form-control" @change="$v.form.language.$touch()" v-model="form.language">
              <option v-for="l in languages" v-bind:key="l.languageId" v-bind:value="l.languageId">{{l.languageName}}</option>
          </select>
          <div v-if="$v.form.language.$dirty">
            <div class="text-danger" v-if="!$v.form.language.required">Language is required!</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">First name</label>
          <input type="text" class="input form-control" @input="$v.form.firstname.$touch()" v-model.trim="form.firstname" />
          <div v-if="$v.form.firstname.$dirty">
            <div class="text-danger" v-if="!$v.form.firstname.required">First name is required!</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Last name</label>
          <input type="text" class="input form-control" @input="$v.form.lastname.$touch()" v-model.trim="form.lastname" />
          <div v-if="$v.form.lastname.$dirty">
            <div class="text-danger" v-if="!$v.form.lastname.required">Last name is required!</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Password</label>
          <input type="password" class="input form-control" @input="$v.form.password.$touch()" v-model.trim="form.password" />
          <div v-if="$v.form.password.$dirty">
            <div class="text-danger" v-if="!$v.form.password.required">Password is required!</div>
          </div>
          <div v-if="errors != null">
            <div class="text-danger" v-for="e in errors" v-bind:key="e.code" >{{e.description}}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Confirm password</label>
          <input type="password" class="input form-control" @input="$v.form.confirmpassword.$touch()" v-model.trim="form.confirmpassword" />
          <div v-if="$v.form.confirmpassword.$dirty">
            <div class="text-danger" v-if="!$v.form.confirmpassword.required">Password is required!</div>
            <div class="text-danger" v-if="!$v.form.confirmpassword.sameAsPassword">Passwords don't match</div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="gdprCheck" @input="$v.form.gdprok.$touch()" v-model="form.gdprok">
            <label v-if="form.language == 'Nederlands'" class="form-check-label" for="gdprCheck">
              Ik accepteer de Chrono Logic Online <a href="/terms-and-conditions" target="_blank">Gebruiksvoorwaarden</a> en <a href="/privacy-policy" target="_blank">Privacyverklaring</a>
            </label>
            <label v-if="form.language == 'Français'" class="form-check-label" for="gdprCheck">
              J'accepte les <a href="/terms-and-conditions" target="_blank">Conditions d'utilisation</a> et  la <a href="/privacy-policy" target="_blank">Déclaration de confidentialité</a> pour Chrono Logic Online.
            </label>
            <label v-if="form.language != 'Nederlands' && form.language != 'Français'" class="form-check-label" for="gdprCheck">
              I agree with the Chrono Logic Online <a href="/terms-and-conditions" target="_blank">Terms and Conditions</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>
            </label>
          </div>
          <div v-if="$v.form.gdprok.$dirty">
            <div class="text-danger" v-if="!$v.form.gdprok.GDPRnotTrue">Must be checked!</div>
          </div>
        </div>

        <div class="text-center">
          <button class="btn btn-primary mb-3" :disabled="loading" type="submit">Register</button>
        </div>
      </form>
    </div>

    <div v-if="form.language == 'Nederlands'" class="modal fade" id="myModal"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Registratie ontvangen</h5>
          </div>
          <div class="modal-body">
            <p>Bedankt voor uw registratie!</p>
            <p></p>
            <p>Gelieve te wachten op een validatie e-mail alvorens in te loggen.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="backToLogin" data-dismiss="modal">Sluiten</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="modal fade" id="myModal"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Registration received</h5>
          </div>
          <div class="modal-body">
            <p>Thank you for your registration!</p>
            <p></p>
            <p>Please wait for a validation e-mail before attempting to log in.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="backToLogin" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import {required, email, sameAs} from "vuelidate/lib/validators";
import store from '../../ClientApp/store';

const GDPRnotTrue = (value) => value == true;

export default {
  components: {
    AppHeader
  },
  data: function () {
    return {
      form: {
        email: '',
        company: '',
        sysco: 1,
        country: 3,
        language: 1,
        firstname: '',
        lastname: '',
        password: '',
        confirmpassword: '',
        gdprok: false
      },
      errors: null,
      countriesloaded: false,
      languagesloaded: false,
      syscosloaded: false
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      company: {
        required
      },
      sysco: {
        required
      },
      country: {
        required
      },
      language: {
        required
      },
      firstname: {
        required
      },
      lastname: {
        required
      },
      password: {
        required
      },
      confirmpassword: {
        required,
        sameAsPassword: sameAs('password')
      },
      gdprok: {
        required,
        GDPRnotTrue
      },
    }
  },
  methods: {
    
    register() {
      this.errors = null;
      this.$v.form.$touch();
      if (this.$v.form.$error) return
      $('#MyModal').modal('show');
      const payload = {
        FirstName: this.form.firstname,
        LastName: this.form.lastname,
        CompanyName: this.form.company,
        SysCo: this.form.sysco,
        Country: this.form.country,
        Language: this.form.language,
        Email: this.form.email,
        Password: this.form.password,
        ConfirmPassword: this.form.confirmpassword,
        GDPROK: this.form.gdprok
      };

      this.$store
        .dispatch("register", payload)
        .then(response => {
          this.error = null;
          $('#myModal').modal('show');
        })
        .catch(error => {
          if (typeof error.data === "string" || error.data instanceof String) {
            this.errors = {
              error: [error.data]
            };
          } else {
            this.errors = error.data;
          }
        });
    },
    backToLogin(){
      this.$router.push("/login");
    },
    showGDPR(){
      $('#GDPR_Ned').modal('show');
    }
  },
  mounted(){
    this.$store.dispatch("getCountries")
    .then(response => {
      this.countriesloaded = true;
    });
    this.$store.dispatch("getLanguages")
    .then(response => {
      this.languagesloaded = true;
    });
    this.$store.dispatch("getSysCos")
    .then(response => {
      this.syscosloaded = true;
    });
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    countries() {
      return this.$store.getters.getCountries;
    },
    languages() {
      return this.$store.getters.getLanguages;
    },
    syscos() {
      return this.$store.getters.getSysCos;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/intro/RegisterForm.vue